import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {ApiServiceService} from "../../../../../Services/api-service.service";
import {FormService} from "../form.service";

@Component({
  selector: 'app-informal-landing',
  templateUrl: './corporate-landing.component.html',
  styleUrls: ['./corporate-landing.component.css']
})
export class CorporateLandingComponent implements OnInit{

  step: number;

  constructor(private formservice: FormService,private router:Router,
              private apiServer:ApiServiceService) {
      this.step = this.formservice.getStep();
      this.formservice.message$.subscribe((message) => {
      this.step = message;
    });
  }

  ngOnInit() {
  }

}
